export const business = {
  legalName: "ИП Флагман Строй",
  name: "Флагман Строй",
  shortName: "Флагман",
  tagline: "Механизированная штукатурка и полусухая стяжка в Чечне",
  foundedYear: 2010,
  projectsCount: 1000,

  siteUrl: "https://stroyflagman.com",

  address: {
    region: "Чеченская Республика",
    country: "RU",
    countryName: "Россия",
  },

  phone: {
    display: "+7 929 888-55-51",
    e164: "+79298885551",
    manager: "Милана",
  },

  email: "info@flagmanstroy.com",
  // Fallback recipient for Resend if CONTACT_EMAIL is not set.
  defaultContactEmail: "info@stroyflagman.com",
  defaultFromEmail: "Flagman Stroy <no-reply@stroyflagman.com>",

  social: {
    instagram: "https://instagram.com/flagman_stroy95",
    instagramHandle: "flagman_stroy95",
    telegram: "https://t.me/flagman_stroy95",
  },

  // Used by privacy policy "last updated" line and footer year.
  privacyLastUpdated: "8 октября 2025 года",
} as const;

export type Business = typeof business;

export const telHref = `tel:${business.phone.e164}`;
export const mailHref = `mailto:${business.email}`;
export const instagramHref = business.social.instagram;
export const telegramHref = business.social.telegram;
